var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMistralLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-8630e1c5-ae2d-441f-9196-1763a523a2fe",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-dc9f10fd-e6c8-4206-a12c-13a9067db880 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-dc9f10fd-e6c8-4206-a12c-13a9067db880",
    d: "M21.01,9.26h-1.62v2.7h-2.78v2.7h-1.36v-2.7h-2.67v-2.7h-4.09v13.48h4.09v-5.39h1.36v2.7h4.09v-2.7h1.36v5.39h4.11v-13.48h-2.49,0ZM8.72,22.52v-13.04h1.17v13.04h-1.17ZM14.17,19.82v-2.47h1.17v2.47h-1.17ZM16.83,14.65v-2.47h1.3v2.47h-1.3,0ZM19.61,9.48h1.19v2.47h-1.19v-2.47ZM19.61,22.52v-5.17h1.19v5.17h-1.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistralLogo);
export default __webpack_public_path__ + "static/media/MistralLogo.0cf248dae4e221aa8b24527020ee981e.svg";
export { ForwardRef as ReactComponent };